import { render, staticRenderFns } from "./integralPeopleItem.vue?vue&type=template&id=58fe621c&scoped=true&"
import script from "./integralPeopleItem.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItem.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItem.vue?vue&type=style&index=0&id=58fe621c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe621c",
  null
  
)

export default component.exports